export default __webpack_public_path__ + "ins-active-association.svg";